import {
    ADD_NEW_USER_SUCCESS,
    ADD_NEW_USER_FAILURE,
    GET_LIST_ALL_PROJECT_SUCCESS,
    GET_LIST_ALL_PROJECT_FAILURE

} from "../actions/Types";

import redexState from "./InitalState";




// get All list users
export const projects = (state = redexState.projectInitalState, action) => {
    switch (action.type) {
      
        case GET_LIST_ALL_PROJECT_SUCCESS:
            return {
                ...state,
                ...action.payload.projectInfo
            }
        case GET_LIST_ALL_PROJECT_FAILURE:
            return {
                ...state,
            }
        default:
            return {...state}
    }

}